export const flatsViews = {
  grid: 'grid',
  table: 'table',
  camera: 'camera'
};
